/** Player settings (graphics, audio), saved per player. A Solid store: the
 *  Settings screen reacts to it; the renderer just reads it. */

import { createStore } from "solid-js/store";

export interface Settings {
  /** Render resolution as a share of the display's (1: native, up to 2x). */
  resolution: number;
  /** Close-up terrain detail and soft ground borders. */
  terrainDetail: boolean;
  /** Shell bursts and death marks. */
  effects: boolean;
  master: number;
  effectsVolume: number;
  music: number;
  /** Music at all (the slider keeps its level while it's off). */
  musicOn: boolean;
}

const DEFAULTS: Settings = { resolution: 1, terrainDetail: true, effects: true, master: 80, effectsVolume: 80, music: 60, musicOn: true };
const STORE = "ferro-settings";

const saved: Settings = (() => {
  try {
    return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(STORE) ?? "{}") };
  } catch {
    return { ...DEFAULTS };
  }
})();

const [store, setStore] = createStore<Settings>(saved);
export const settings = store;

export function setSetting<K extends keyof Settings>(key: K, value: Settings[K]): void {
  setStore(key, value as never);
  try {
    localStorage.setItem(STORE, JSON.stringify(store));
  } catch {
    /* this session only */
  }
}
